import {useRequestHelper} from "@/core/helpers/request.helper";
import type {LoginColaboradorCommand} from "@/modules/usuario/commands/auth.commands";
import type {VerificarUsuarioSessaoCommand} from "@/modules/usuario/commands/usuario.commands";
import type {UsuarioVm} from "@/modules/usuario/type/usuario.type";
import type {UsuarioLoginVm} from "@/modules/usuario/type/auth.type";



const requestHelper = useRequestHelper();



class AuthService {

    login(userCommand: LoginColaboradorCommand) {
        return requestHelper.sendRequestPost<UsuarioLoginVm>('usuario/login', userCommand, false);
    }

    verificarSessao(command: VerificarUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<UsuarioLoginVm>('usuario/sessao/verificar', command, false);
    }

    verificarUsuarioAutenticado() {
        return requestHelper.sendRequestGet<UsuarioVm>('usuario/info');
    }



}

export default new AuthService();